export { default } from '@framework/tenant/config/dmPortal';
